import React from 'react';
import { Outlet } from 'react-router-dom';

const LandingLayout = () => {
    return (
        <div className="min-h-screen w-full bg-[var(--bg-dark)] text-white overflow-x-hidden">
            <Outlet />
        </div>
    );
};

export default LandingLayout;
